<app-profile-sources-info
  class="profile-sources-info"
  [size]="'small'"
  [sources]="fullCandidateSources"
  [revealedInfo]="revealedCardInfo"></app-profile-sources-info>
